import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['organizations'];

  connect() {
    this.organizationsTarget.addEventListener('change', this.organizationSelected.bind(this));
  }

  organizationSelected() {
    const url = window.location.href;
    Turbo.visit(
      `/admin/vote_boxes/render_users?organization_id=${this.organizationsTarget.value}`,
      { action: 'replace' }
    );
    history.pushState(null, null, url);
  }
}
